<template>
  <div class="filter-wrapper">
    <b-row class="mb-4">
      <div 
        v-for="filter in filters" 
        :key="filter.key"
        class="col"
      >
        <!-- String/Text Input -->
        <b-input
          v-if="filter.type === 'string'"
          size="sm"
          :placeholder="filter.placeholder"
          v-model="filterValues[filter.key]"
          @keyup.enter="onFilter"
        />

        <!-- Select Dropdown -->
        <b-form-select
          v-else-if="filter.type === 'select'"
          size="sm"
          v-model="filterValues[filter.key]"
          :options="filter.options"
          :value-field="filter.valueField || 'id'"
          :text-field="filter.textField || 'name'"
          :placeholder="filter.placeholder"
        />

        <!-- Date Input -->
        <b-form-input
          v-else-if="filter.type === 'date'"
          size="sm"
          type="date"
          v-model="filterValues[filter.key]"
          :placeholder="filter.placeholder"
        />

        <!-- Custom Dropdown -->
        <BDropdownCustom
          v-else-if="filter.type === 'custom-dropdown'"
          v-model="filterValues[filter.key]"
          :options="filter.options"
          :placeholder="filter.placeholder"
          :searchable="filter.searchable || false"
          :matchKey="filter.matchKey || ['name']"
          :limit="filter.limit || 10"
        />

        <!-- Autosuggest -->
        <Autosuggest
          v-else-if="filter.type === 'autosuggest'"
          :model="filterValues[filter.key]"
          :suggestions="filter.options"
          :placeholder="filter.placeholder"
          @select="(option) => onAutosuggestSelect(filter.key, option)"
          @change="(text) => onAutosuggestChange(filter.key, text)"
        />

        <!-- Number Input -->
        <b-form-input
          v-else-if="filter.type === 'number'"
          size="sm"
          type="number"
          v-model="filterValues[filter.key]"
          :placeholder="filter.placeholder"
          :min="filter.min"
          :max="filter.max"
        />

        <!-- Default to string input -->
        <b-input
          v-else
          size="sm"
          :placeholder="filter.placeholder"
          v-model="filterValues[filter.key]"
          @keyup.enter="onFilter"
        />
      </div>
    </b-row>

    <b-row class="mb-4">
      <b-col md="1">
        <b-button
          variant="primary"
          size="sm"
          @click="onFilter"
        >
          Lọc
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

export default {
  name: 'FilterWrapper',
  components: {
    BDropdownCustom,
    Autosuggest,
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filterValues: {},
    };
  },
  created() {
    this.filters.forEach(filter => {
      this.$set(this.filterValues, filter.key, filter.defaultValue || '');
    });
  },
  methods: {
    onFilter() {
      const filteredValues = {};
      Object.keys(this.filterValues).forEach(key => {
        const value = this.filterValues[key];
        if (value !== null && value !== undefined && value !== '') {
          if (Array.isArray(value)) {
            if (value.length > 0) {
              filteredValues[key] = value;
            }
          } else {
            filteredValues[key] = value;
          }
        }
      });
      
      this.$emit('filter', filteredValues);
    },

    onAutosuggestSelect(key, option) {
      this.filterValues[key] = option.item.name;
    },

    onAutosuggestChange(key, text) {
      this.filterValues[key] = text;
    },

    resetFilters() {
      this.filters.forEach(filter => {
        this.$set(this.filterValues, filter.key, filter.defaultValue || '');
      });
    },

    setFilterValue(key, value) {
      this.$set(this.filterValues, key, value);
    },

    getFilterValue(key) {
      return this.filterValues[key];
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  .col {
    margin-bottom: 0.5rem;
  }
}
</style> 